export default __webpack_public_path__ + "static/media/astro.a297af75.svg";